function setScrollbarWidth() {
    const width = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
}

function setViewport() {

    const defaults = {
        debugging: false,
        metatag: {
            value: "width=device-width, initial-scale=1, shrink-to-fit=yes, viewport-fit=cover"
        }
    };

    const breakpoints = [
        {
            breakpoint: 0,
        },
        {
            breakpoint: 640,
            min_width: 1024
        },
        {
            breakpoint: 1024,
        },
    ];

    const getViewportMetatag = function(breakpoint){

        let metatag = document.createElement("meta");

        metatag.setAttribute("name", "viewport");

            // Set value of metagtag

        let content = defaults.metatag.value;

        if (typeof breakpoint.min_width === "number"){
            content = "width=" + breakpoint.min_width + ", shrink-to-fit=yes, viewport-fit=cover";
        }

        metatag.setAttribute("content", content);

        return metatag;

    }

    const removeViewportMetatags = function (){

        for (let metatags = document.getElementsByTagName("meta"), i = metatags.length - 1; i >= 0; i--){

            if (metatags[i].getAttribute("name") === "viewport"){
                metatags[i].remove();
            }

        }

    }

    const attachViewportMetatag = function (breakpoint){

            // Remove old viewport metatag(s)

        removeViewportMetatags();

            // Create new viewport metatag

        let metatag = getViewportMetatag(breakpoint);

            // Append metatag to head

        document.head.appendChild(metatag);

        if (defaults.debugging){
            showMessage("Set viewport to: " + metatag.getAttribute("content"));
        }

    }

    const showMessage = function(content) {

        let container = document.createElement("pre");

        container.setAttribute("class", "message");
        container.innerHTML = content;

        document.body.appendChild(container);

    }

    const getBreakpoint = function(){

            // Only run script on mobile devices

        if (typeof window.onorientationchange === "undefined"){
            return;
        }

        // Check breakpoints in descending order

        let breakpoint = 0;

        for (let i = breakpoints.length - 1; i >= 0; i--){

            if (document.documentElement.clientWidth > breakpoints[i].breakpoint){
                breakpoint = breakpoints[i].breakpoint;
                attachViewportMetatag(breakpoints[i]);
                break;
            }

        }

        return breakpoint;

    }

    const current_breakpoint = getBreakpoint();


        // Reload on orientation changes

    window.addEventListener("orientationchange", function() {

        const html = document.querySelector("html");

        html.style.opacity = 0;

            // Set viewport to default `width=device-width`

        attachViewportMetatag(breakpoints[0]);

        setTimeout(
            function(){

                if (typeof current_breakpoint === "undefined" || getBreakpoint() !== current_breakpoint){
                    // If breakpoint changes then reload page
                    window.location.reload();
                }

                html.style.opacity = 1;

            },
            50
        );


    }, false);

}

export {
    setScrollbarWidth,
    setViewport
}
